define('components/decorators/main-menu',[
    'jquery'
],function($){

    $.extend(companyInfo.decorators,{

        'main-menu': function(e) {
            // TODO: make this rerun on viewport width change
            var menu = $(this);
            var smallToggle = $('<a href="#menu" class="toggle-menu" data-handler="toggle-menu">Menu<i class="ico ico-end ico-caret-down"></i></a>');
            var more = $('<li><a href="#meer" data-handler="toggle-submenu"><span>' + companyInfo.labels.more + '</span><i class="ico ico-end ico-caret-down"></i></a><div><ul/></div></li>');
            var moreContainer = more.find('ul');
            var items = menu.find('> li:not([class|="menu"])');
            menu.before(smallToggle);

            function truncate(){
                var maxWidth, currentWidth, index, accountWidth;
                var moreButtonWidth = more.width() || 90;
                more.remove();
                menu.prepend(items);
                if (companyInfo.size() > 1) {

                    maxWidth = menu.width();
                    // reserving room for more button.
                    currentWidth = moreButtonWidth;
                    index = 0;

                    while ( index < items.length ) {
                        currentWidth += $(items[index]).width();
                        if ( currentWidth < maxWidth ) {
                            menu.append(items[index]);
                        } else {
                            moreContainer.append(items[ index]);
                            menu.append(more);
                        }
                        index++;
                    }
                }
            }

            truncate();

            var timeout;
            $(window).on('resize',truncate);

        }

    });

    function getItems( menu ){
        var items = [];
        menu.find('> li:not([class|="menu"])').each(function(){
            items.push({
                width: $(this).outerWidth(true),
                el: $(this)
            });
        });
        return items;
    }

});

